import React from 'react';
import ReactDOM from 'react-dom/client';
import LandingPage from './LandingPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<LandingPage />);
